import {ChekinPro} from './ChekinPro';
export default {ChekinPro};